import React from 'react';
import Paper from 'material-ui/Paper';
import Button from 'material-ui/Button';
import { LinearProgress } from 'material-ui/Progress';
import OLYWebPageComponent from '../OLYWebPageComponent';
import DynIcon from '../Utils/DynIcon';
import { translate } from 'react-i18next';
import { Typography, withStyles, TextField } from '../../../node_modules/material-ui';
import Input, { InputAdornment, InputLabel } from 'material-ui/Input';
import IconButton from 'material-ui/IconButton';
import { FormControl, FormHelperText } from 'material-ui/Form';
import { validatePassword, adminResetPassword } from './../ChangePassword/ChangePasswordService';

const styles = theme => ({
    tableTitle: {
        color: theme.palette.primary.main,
        fontSize: 24,
        fontWeight: 300,        
    },
    inputLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        color: 'var(--secondary-button-color)',              
    },
    FormControl: {
        display: 'flex',
        width: '400px',
        margin: '1.2rem 0 0 0'        
    }
});
class ResetPasswordView extends OLYWebPageComponent {
    constructor(props) {
        super(props, 'ResetPasswordView');
        this.pageName = 'ResetPasswordView';
        this.state = {
            loading: false,
            disableChangeButton: true,
            failed: false,
            message: '',
            username: '',
            newPassword: '',
            verifyPassword: ''
        };
    }

    validatePassword = () => {
        const validationResult = validatePassword(this.state.newPassword,
            this.state.verifyPassword);
        this.setState({
            failed: validationResult.failed,
            disableChangeButton: validationResult.failed,
            message: validationResult.message
        });
    }

    setPassword(value) {
        this.setState({ newPassword: value }, () => {
            this.validatePassword();
        });
    }

    setVerifyPassword(value) {
        this.setState({ verifyPassword: value }, () => {
            this.validatePassword();
        });
    }

    generateToken = () => {
        this.setState({ loading: true });
        adminResetPassword(this.state.username, this.state.verifyPassword)
            .then(result => {
                this.setState({
                    failed: false,
                });
                alert(this.props.t('RECOVER_PASSWORD.RECOVER_SUCCESS'));
            }).catch(error => {
                //Esto ya lo traduce el backend
                this.setState({
                    failed: true,
                });
                alert(error.message);
            })
            .finally(res => {
                this.setState({ loading: false });
            });
    }

    render() {
        const { classes, t } = this.props;
        return (
            <div className="cmsBackResetPass">
                <div style={{ margin: '5px' }}>
                    {this.state.loading ? <LinearProgress className="cmsProgressBar" /> : ''}
                </div>
                <Paper style={{ margin: 15, padding: 20 }}>
                    <Typography className={classes.tableTitle}>
                        <DynIcon icon="Lock" style={{ width: 32, height: 32, float: 'left' }} />
                        <strong style={{ paddingLeft: 8 }}>{t('PAGE_TITLES.' + this.pageName)}</strong>
                    </Typography>
                    <p style={{ paddingLeft: 38 }}>{t('ResetPasswordView.INTRO_TEXT')}</p>
                    <Typography style={{ maxWidth: '420px', paddingLeft: 38  }}>{t('ResetPasswordView.LEYEND')}</Typography>                    
                    <div style={{ paddingLeft: 38 , margin:'0 0 3rem 0' }}>
                    <FormControl className={classes.FormControl} component="fieldset">
                        <TextField
                            id="username"
                            label={t('COMMON.USER')}
                            required={true}
                            onChange={event => {
                                this.setState({
                                    username: String(event.target.value),
                                });
                            }}
                            InputProps={{
                                startAdornment:
                                    <InputAdornment position="start">
                                        <DynIcon icon="AccountCircle" />
                                    </InputAdornment>
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                            helperText={t('ResetPasswordView.PLEASE_ENTER_USER')}
                        />
                        <br />
                        </FormControl>
                        <FormControl className={classes.FormControl}  component="fieldset" error={this.state.failed}>
                            <InputLabel htmlFor="newPassword">{t('LOGIN.PASSWORD')}</InputLabel>
                            <Input
                                id="newPassword"
                                required={true}
                                type={this.state.showPassword ? 'text' : 'password'}
                                startAdornment={<DynIcon icon="Lock" />}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() => this.setState({ showPassword: !this.state.showPassword })}>
                                            {this.state.showPassword ? <DynIcon icon="VisibilityOff" /> : <DynIcon icon="Visibility" />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                                onChange={event => {
                                    this.setPassword(String(event.target.value));
                                }}
                            />
                        </FormControl>
                        <br />
                        <FormControl component="fieldset" className={classes.FormControl}  error={this.state.failed}>
                            <InputLabel htmlFor="verifyPassword">{t('RECOVER_PASSWORD.VERIFY_PASSWORD')}</InputLabel>
                            <Input
                                id="verifyPassword"
                                required={true}
                                type={this.state.showVerifyPassword ? 'text' : 'password'}
                                startAdornment={<DynIcon icon="Lock" />}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() => this.setState({ showVerifyPassword: !this.state.showVerifyPassword })}>
                                            {this.state.showVerifyPassword ? <DynIcon icon="VisibilityOff" /> : <DynIcon icon="Visibility" />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                                onChange={event => {
                                    this.setVerifyPassword(String(event.target.value));
                                }}
                            />
                        </FormControl>
                        <FormControl component="fieldset" className={classes.FormControl} >
                        {this.state.failed ? (
                            <FormHelperText style={{ color: 'red', width: '320px', padding:'0 0 2rem 0'}}>
                                {t(this.state.message)}
                            </FormHelperText>
                        ) : (
                            ''
                        )}
                        <br />
                        <Button variant="raised" color="secondary"
                            style={{color:'var(--secondary-button--text-color)', backgroundColor: 'var(--secondary-button-color)', height: '3rem'}}
                            disabled={this.state.loading || this.state.disableChangeButton}
                            onClick={() => this.generateToken()}>{t('ResetPasswordView.MAIN_BUTTON')}</Button>
                        <br />
                    </FormControl>
                    </div>
                </Paper>
            </div>
        );
    }
}

export default translate('translations')(withStyles(styles)(ResetPasswordView));


// WEBPACK FOOTER //
// ./src/components/BackOffice/ResetPasswordView.js